import VehicleCardDa from "./da/quotes/vehicle_card";
import VehicleCardDe from "./de/quotes/vehicle_card";
import VehicleCardEn from "./en/quotes/vehicle_card";
import VehicleCardEs from "./es/quotes/vehicle_card";
import VehicleCardFi from "./fi/quotes/vehicle_card";
import VehicleCardFr from "./fr/quotes/vehicle_card";
import VehicleCardHr from "./hr/quotes/vehicle_card";
import VehicleCardIt from "./it/quotes/vehicle_card";
import VehicleCardLt from "./lt/quotes/vehicle_card";
import VehicleCardLv from "./lv/quotes/vehicle_card";
import VehicleCardMe from "./me/quotes/vehicle_card";
import VehicleCardNl from "./nl/quotes/vehicle_card";
import VehicleCardPl from "./pl/quotes/vehicle_card";
import VehicleCardSr from "./sr/quotes/vehicle_card";
import VehicleCardSe from "./se/quotes/vehicle_card";
import VehicleCardTr from "./tr/quotes/vehicle_card";

export default {
    messages: {
        da:{VehicleCard:VehicleCardDa},
        de:{VehicleCard:VehicleCardDe},
        en:{VehicleCard:VehicleCardEn},
        es:{VehicleCard:VehicleCardEs},
        fi:{VehicleCard:VehicleCardFi},
        fr:{VehicleCard:VehicleCardFr},
        hr:{VehicleCard:VehicleCardHr},
        it:{VehicleCard:VehicleCardIt},
        lt:{VehicleCard:VehicleCardLt},
        lv:{VehicleCard:VehicleCardLv},
        me:{VehicleCard:VehicleCardMe},
        mx:{VehicleCard:VehicleCardEs},
        nl:{VehicleCard:VehicleCardNl},
        pl:{VehicleCard:VehicleCardPl},
        sr:{VehicleCard:VehicleCardSr},
        se:{VehicleCard:VehicleCardSe},
        tr:{VehicleCard:VehicleCardTr},
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/VehicleCard.js